import { PageLayoutProps, PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { PageContextValue } from 'components/PageContext';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';
import { useMemo } from 'react';

type UsePageLayoutContentSidebarProps = (pageContext: PageContextValue) => PageLayoutProps;
export const usePageLayoutContentSidebarProps: UsePageLayoutContentSidebarProps = (pageContext) => {
  const isVivaEngageApp = useIsVivaEngageApp();

  return useMemo(() => {
    const baseProps = {
      showContentSidebarAriaLabel: pageContext.showContentSidebarAriaLabel,
    };

    if (!isVivaEngageApp) {
      return baseProps;
    }

    return {
      ...baseProps,
      isPanelExternallyControlled: true,
      isPanelOpen: pageContext.isContentPanelOpen,
      showContentPanelButtonForWidths: [PageLayoutWidth.Small],
      closePanel: pageContext.closeContentPanel,
      openPanel: pageContext.openContentPanel,
    };
  }, [isVivaEngageApp, pageContext]);
};
